import * as Sentry from '@sentry/vue'
import { App } from 'vue'
import { Router } from 'vue-router'
export default function sentryInit(app: App, router: Router) {
  Sentry.init({
    app,
    dsn: window.appConfig.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      // fixes "instrument.js" as the only console source when logging
      Sentry.breadcrumbsIntegration({ console: false })
    ],
    tracePropagationTargets: [window.appConfig.VITE_API_BASE_URL ?? '', /^\//],
    environment: window.appConfig.VITE_SENTRY_ENVIRONMENT,
    tracesSampleRate: parseFloat(String(window.appConfig.VITE_SENTRY_TRACES_SAMPLE_RATE)),
    release: '1.0.0',
    debug: false
  })
}
